import {
  useDeleteDefaultPaymentMethodMutation,
  useSetDefaultPaymentMethodMutation,
} from '@/api/api.slice.tsx';
import { GetWireTransferSetupResponse } from '@/features/means-of-payments/api/useGetWireTransferSetupQuery.ts';
import {
  Alert,
  Button,
  getMessageFromError,
} from '@arsnovasystems/ars-front-lib';
import { useTranslation } from 'react-i18next';

/**
 * Make default button component
 *
 * @param props      Props
 * @param props.data corresponding data
 *
 * @returns          MakeDefaultButton component
 */
export const MakeDefaultButton = ({
  data,
}: {
  data: GetWireTransferSetupResponse;
}) => {
  const [setDefaultPaymentMethodTrigger, setDefaultPaymentMethodResult] =
    useSetDefaultPaymentMethodMutation();
  const [deleteDefaultPaymentMethodTrigger, deleteDefaultPaymentMethodResult] =
    useDeleteDefaultPaymentMethodMutation();

  const { t } = useTranslation();
  const handleClick = async () => {
    if (data.id === 'blank') {
      await deleteDefaultPaymentMethodTrigger();
    } else {
      await setDefaultPaymentMethodTrigger(data.id);
    }
  };

  return (
    <>
      <Button
        loading={
          deleteDefaultPaymentMethodResult.isLoading ||
          setDefaultPaymentMethodResult.isLoading
        }
        variant='contained'
        color='secondary'
        disabled={data.isDefault}
        onClick={handleClick}
      >
        {t('ik.make.default')}
      </Button>
      {setDefaultPaymentMethodResult.error && (
        <Alert sx={{ marginY: 1 }}>
          {getMessageFromError(setDefaultPaymentMethodResult.error)}
        </Alert>
      )}
      {deleteDefaultPaymentMethodResult.error && (
        <Alert sx={{ marginY: 1 }}>
          {getMessageFromError(deleteDefaultPaymentMethodResult.error)}
        </Alert>
      )}
    </>
  );
};
